var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.8074 7.02764C14.9936 7.215 15.0981 7.46845 15.0981 7.73264C15.0981 7.99683 14.9936 8.25028 14.8074 8.43764L11.2674 12.0276L14.8074 15.5676C14.9936 15.755 15.0981 16.0085 15.0981 16.2726C15.0981 16.5368 14.9936 16.7903 14.8074 16.9776C14.7144 17.0714 14.6038 17.1458 14.4819 17.1965C14.3601 17.2473 14.2294 17.2734 14.0974 17.2734C13.9653 17.2734 13.8346 17.2473 13.7128 17.1965C13.5909 17.1458 13.4803 17.0714 13.3874 16.9776L9.14735 12.7376C9.05362 12.6447 8.97923 12.5341 8.92846 12.4122C8.87769 12.2904 8.85155 12.1597 8.85155 12.0276C8.85155 11.8956 8.87769 11.7649 8.92846 11.6431C8.97923 11.5212 9.05362 11.4106 9.14735 11.3176L13.3874 7.02764C13.4803 6.93391 13.5909 6.85952 13.7128 6.80875C13.8346 6.75798 13.9653 6.73184 14.0974 6.73184C14.2294 6.73184 14.3601 6.75798 14.4819 6.80875C14.6038 6.85952 14.7144 6.93391 14.8074 7.02764Z",
    fill: "#828282"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGray);
export default __webpack_public_path__ + "static/media/arrow_gray.ab658dccb03015feae65b8f648bba193.svg";
export { ForwardRef as ReactComponent };